
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_ptw8i_12rmg_181",
  "hovered": "awsui_hovered_ptw8i_12rmg_194",
  "content": "awsui_content_ptw8i_12rmg_201"
};
  